import { useState, useEffect } from 'react';
import useScript from '../../hooks/useScript';
import { isStaging, trackingEnabled } from '../../utils/env';

export function TrackingScripts() {
  const [hasConsent, setHasConsent] = useState(
    () => localStorage.getItem('cookieConsent') === 'accepted'
  );

  useEffect(() => {
    const handleConsentChange = () => {
      setHasConsent(localStorage.getItem('cookieConsent') === 'accepted');
    };
    window.addEventListener('cookieConsentChanged', handleConsentChange);
    window.addEventListener('storage', handleConsentChange);
    return () => {
      window.removeEventListener('cookieConsentChanged', handleConsentChange);
      window.removeEventListener('storage', handleConsentChange);
    };
  }, []);

  const isTrackingActive = trackingEnabled && hasConsent;

  // 1. Google Analytics / gtag (only when tracking is enabled and user consented)
  useScript({
    id: 'gtag-js',
    src: 'https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXX',
    enabled: isTrackingActive,
    async: true,
  });

  useScript({
    id: 'gtag-config',
    enabled: isTrackingActive,
    innerHTML: `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-XXXXXXXX', { send_page_view: true });
    `,
  });

  // 3. Hotjar (only when tracking is enabled and user consented)
  useScript({
    id: 'hotjar',
    enabled: isTrackingActive,
    innerHTML: `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:1234567,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `,
  });

  // 4. Meta Pixel (only when tracking is enabled and user consented)
  useScript({
    id: 'meta-pixel',
    enabled: isTrackingActive,
    innerHTML: `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', 'YOUR_PIXEL_ID');
      fbq('track', 'PageView');
    `,
  });

  // 5. Microsoft Clarity (only when tracking is enabled and user consented)
  useScript({
    id: 'clarity',
    enabled: isTrackingActive,
    innerHTML: `
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vr5hzezf9v");
    `,
  });

  // 6. Tawk.to Chat Widget (always enabled for customer support, without env or consent gating)
  useScript({
    id: 'tawk-to',
    enabled: true,
    innerHTML: `
      window.Tawk_API=window.Tawk_API||{};
      window.Tawk_LoadStart=new Date();
      (function(){
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/6a0640936046481c318ecab6/1jok6ogrp';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
      })();
    `,
  });

  return null;
}

export default TrackingScripts;
